import addressesConstants from 'utils/addresses/constants';
import { areAllTrue } from 'utils/array';
import { isEmpty, isStringAndNotNull } from 'utils/types';

const response = (isValid, error) => ({
  isValid,
  error: isValid ? undefined : error,
});
const isValidationDefined = (rules, rule) =>
  Object.keys(rules).indexOf(rule) >= 0;

const validateAddressInput = ({ field, value, country }) => {
  const validatorsByFieldKey = {
    [addressesConstants.FIELDS_NAMES.company_name]: (companyName) =>
      isStringAndNotNull(companyName),
    [addressesConstants.FIELDS_NAMES.address_line]: (addressLine) =>
      isStringAndNotNull(addressLine),
    [addressesConstants.FIELDS_NAMES.contact_name]: () => true,
    [addressesConstants.FIELDS_NAMES.contact_phone]: (contactPhone) =>
      isEmpty(contactPhone) || /^\+?[0-9]\d{1,14}$/.test(contactPhone),
    [addressesConstants.FIELDS_NAMES.city]: (city) => {
      if (country === 'FR') {
        return isStringAndNotNull(city);
      }

      return true;
    },
  };

  return isValidationDefined(validatorsByFieldKey, field)
    ? response(validatorsByFieldKey[field](value), field)
    : response(true, field);
};

const populateWithEmptyFields = (address) => ({
  ...Object.values(addressesConstants.FIELDS_NAMES).reduce(
    (acc, fieldKey) => ({ ...acc, [fieldKey]: undefined }),
    {}
  ),
  ...address,
});

const validateAddress = ({ address }) => {
  const populatedAddress = populateWithEmptyFields(address);

  const validations = Object.keys(populatedAddress).map((addressKey) =>
    validateAddressInput({
      field: addressKey,
      value: populatedAddress[addressKey],
      country: address && address.country,
    })
  );

  return {
    isValid: areAllTrue(validations.map((validation) => validation.isValid)),
    errors: validations.reduce(
      (acc, validation) =>
        validation.error ? [...acc, validation.error] : acc,
      []
    ),
  };
};

export default validateAddress;
